import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { BtsService } from '../../app/core/bts.service';
import { MeasureService } from '../../app/core/measure.service';
import { MeasureLocalService } from '../../app/core/local-data-services/measure-local.service';
import { BT, Measure } from '../../app/models/models';

@Injectable()
export class SummaryService {

  constructor(private btsService: BtsService,
              private measureService: MeasureService,
              private measureLocalService: MeasureLocalService) {

  }

  public calculateMissingPksByBtAndLocation(measuresByBtAndLocation: Map<string, Map<string, Measure[]>>): Map<string, Map<string, number[]>> {
    let allMissingPks: Map<string, Map<string, number[]>> = new Map();

    measuresByBtAndLocation.forEach((measuresByBt: Map<string, Measure[]>, btString: string) => {
      measuresByBt.forEach((measures: Measure[], locationString: string) => {
        let missingPks: number[] = [];
        let minNumber = this.getMinPkNumber(measures);
        let maxNumber = this.getMaxPkNumber(measures);
        for (let i = minNumber; i <= maxNumber; i += 5) {
          if (!measures.find(measure => measure.pk.number == i)) {
            missingPks.push(i);
          }
        }
        if (missingPks.length) {
          allMissingPks.set(btString, new Map());
          allMissingPks.get(btString).set(locationString, missingPks);
        }
      });
    });
    return allMissingPks;
  }

  public getSpecificMeasures(allMeasuresByBt: Map<string, Measure[]>): Map<string, Measure[]> {
    let specificMeasures: Map<string, Measure[]> = new Map();

    allMeasuresByBt.forEach((measures: Measure[], btString: string) => {
      measures = measures.filter(
        measure => measure.isSpecific === true
      );
      if (measures.length) {
        specificMeasures.set(btString, measures);
      }
    });

    return specificMeasures;
  }

  public getMaxPkNumber(measures: Measure[]): number {
    return Math.max.apply(Math, measures.map(measure => measure.pk.number));
  }

  public getMinPkNumber(measures: Measure[]): number {
    return Math.min.apply(Math, measures.map(measure => measure.pk.number));
  }

  public organizeMeasuresByBt(measures: Measure[]): Map<string, Measure[]> {
    let measuresByBt: Map<string, Measure[]> = new Map();

    measures.map(measure => {
      let bt = Object.assign(new BT(), measure.bt);
      if (!measuresByBt.has(bt.toString())) {
        measuresByBt.set(bt.toString(), []);
      }
      measuresByBt.set(
        bt.toString(),
        measuresByBt.get(bt.toString()).concat([measure])
      );
    });

    return measuresByBt;
  }

  public organizeMeasuresByBtAndLocation(allMeasuresByBt: Map<string, Measure[]>): Map<string, Map<string, Measure[]>> {
    let allMeasuresByBtAndLocation: Map<string, Map<string, Measure[]>> = new Map();

    allMeasuresByBt.forEach((measures: Measure[], btString: string) => {
      allMeasuresByBtAndLocation.set(btString, new Map());

      measures.forEach(measure => {
        if (measure.isSpecific) {
          return;
        }
        let measuresByBt = allMeasuresByBtAndLocation.get(btString);
        let currentLocationString = JSON.stringify({
          line: measure.pk.line.name,
          potential: measure.pk.potential,
          way: measure.pk.way
        });
        let measuresByBtAndCurrentLocation = measuresByBt.get(currentLocationString) || [];
        measuresByBtAndCurrentLocation.push(measure);
        measuresByBt.set(currentLocationString, measuresByBtAndCurrentLocation);
      });
    });

    return allMeasuresByBtAndLocation;
  }

  public parseJSON(jsonString): Object {
    return JSON.parse(jsonString);
  }

  public saveAllBts(): Observable<any> {
    return this.measureLocalService.getDistinctBTs().flatMap(
      (bts: BT[]) => this.btsService.saveAllBts(bts)
    );
  }

  public saveAllMeasures(): Observable<any> {
    return this.saveAllBts()
      .flatMap(() => this.measureLocalService.getAllMeasures())
      .map(measures => measures.map(measure => {
        delete measure.pk.measures;
        return measure;
      }))
      .flatMap(measures => this.measureService.saveAllMeasures(measures))
      .map((savedMeasures: Measure[]) => {
        savedMeasures.forEach((savedMeasure: Measure) => {
          this.measureLocalService.delete(savedMeasure);
        });
      });
  }

  public launchCompute() : void {
    this.measureService.launchComputeOnInsertedMeasure();
  }
}



// WEBPACK FOOTER //
// ./src/pages/summary/summary.service.ts